/**
 * Created by DynamicDog on 2016-12-13.
 *
 * Simple key/vlaue-based translation service.
 * First it tries to find the string in the current locale.
 * If that fails, try to find the string in the default locale.
 * If everyting fails, return the original string with added asterisks (for giving a visual cue)
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
//const translations = {};

@Injectable()
export class TranslateService {
    language:string = '';
    defaultLanguage:string = 'sv';
    translations:any={};

    constructor(private http:Http) {
    }

    public loadTranslation():Promise<any> {
        var instance = this;
        return new Promise(function(resolve,reject) {
            instance.loadLang(instance.language).then(function() {
                if(instance.language !== instance.defaultLanguage) {
                    instance.loadLang(instance.defaultLanguage).then(function () {
                        resolve();
                    }, function (err) {
                        resolve();
                    })
                } else {
                    resolve();
                }
            },function(err) {
                instance.loadLang(instance.defaultLanguage).then(function() {
                    resolve();
                },function(err) {
                    resolve();
                })
            })
        })
    }

    public loadLang(language:string):any {
        var instance = this;
        return new Promise(function(resolve,reject) {
			instance.translations[language] = '';

			if(language === '') {
				reject("Failure");
			} else {
				try {
					instance.http.get('./lang/' + language + '.json').subscribe(res => {
						instance.translations[language] = res.json();
						resolve()
					}, error => reject(error));
				} catch(e) {
					reject("Failure");
				}
			}
        });


    }
    public translate(key: string): string {
        var retVal:string;
        // First try the current language
        if(this.language && this.language.length > 0) {
            retVal = this.translations[this.language][key];
        }

        // If not successful, try the default language
        if(!retVal && this.defaultLanguage && this.defaultLanguage.length > 0) {
            retVal = this.translations[this.defaultLanguage][key];
        }

        // If all fails, return the key (with markers in order to show it's not translated)
        if(!retVal) {
            console.warn("Missing translation ",key);
            retVal = '* '+key+' *';
        }
        return retVal;
    }
}


// WEBPACK FOOTER //
// ./app/services/translate.service.ts